<div class="route-replay-container">
  <!-- Loading Overlay -->
  <div class="loading-overlay" *ngIf="isLoading">
    <div class="spinner-container">
      <div class="spinner"></div>
      <p>Loading route data...</p>
    </div>
  </div>

  <!-- Sidebar with trip-view structure -->
  <div class="sidebar-section">
    <route-side-bar></route-side-bar>
  </div>

  <!-- Main Content Area -->
  <div class="main-content-section">
    <!-- Map View -->
    <div class="map-container">
      <app-map-view></app-map-view>
    </div>

    <!-- Route Player (Timeline) -->
    <div class="player-container">
      <app-route-route-player></app-route-route-player>
    </div>
  </div>
</div>
